"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmount = exports.formatCelularComTraco = exports.formatSazonalidade = exports.getDescontoTarifaPorFonteEnergia = exports.formatCelular = exports.formatCondicoesComerciaisProposta = exports.formatFonteEnergiaPorExtenso = exports.formatFonteEnergiaPerfil = exports.formatSubmercadoPorExtenso = exports.formatSubmercadoPerfil = exports.formatClassePerfil = exports.convertStringToFonteEnergia = exports.convertStringToSubmercado = exports.formatDocumentoStatus = exports.formatCapitalized = exports.formatNomeEmpresarial = exports.formatCurrency = exports.formatNumberFromString = exports.formatVolume = exports.formatNumber = exports.formatPeriod = exports.formatEconomia = void 0;
var luxon_1 = require("luxon");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var numeral_1 = __importDefault(require("numeral"));
var enums_1 = require("../business/data/enums");
var formatterMonthYear = new Intl.DateTimeFormat('pt-BR', {
    year: '2-digit',
    month: 'short',
});
var formatterYear = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
});
exports.formatEconomia = function (n) {
    function round(arg) {
        var fixed = arg.toFixed(0);
        var numberOfDigits = fixed.length;
        if (numberOfDigits <= 9 && numberOfDigits >= 5) {
            var centena = arg
                .toFixed(0)
                .split('')
                .splice(-3)
                .join('');
            if (parseInt(centena, 10) >= 500) {
                return parseInt(fixed.replace(new RegExp(centena + "$"), '000'), 10) + 1000;
            }
            return parseInt(fixed.replace(new RegExp(centena + "$"), '000'), 10);
        }
        return parseInt(fixed, 10);
    }
    var rounded = round(n);
    var formated = rounded.toString().replace(/000$/, '');
    var unidade;
    if (rounded > 9999 && formated.length === 3) {
        unidade = 'mil';
    }
    else if (rounded > 9999 && formated.length > 3) {
        if (parseInt(formated, 10) < 2000) {
            unidade = 'milhão';
        }
        else {
            unidade = 'milhões';
        }
    }
    else {
        unidade = 'mil';
    }
    return [rounded > 9999 ? new Intl.NumberFormat('en-US').format(parseInt(formated, 10)) : formated, unidade];
};
/**
 * O intervalo deve ser fechado em t_start e aberto em t_end
 *
 * @param DateTime tStart
 * @param DateTime tEnd
 */
function formatPeriod(tStart, tEnd, options) {
    var start = tStart.startOf('month');
    var end = tEnd.endOf('month');
    var diff = Number(end.diff(start, 'month').months.toFixed(0));
    var formatStartDate = function (formatter) { return formatter.format(start.toJSDate()); };
    var formatEndDate = function (formatter) { return formatter.format(end.toJSDate()); };
    var value = formatStartDate(formatterMonthYear);
    if (diff > 1 && diff < 12) {
        value = [formatStartDate(formatterMonthYear), formatEndDate(formatterMonthYear)];
    }
    if (diff === 12) {
        value = formatStartDate(formatterYear);
    }
    if (diff > 12) {
        if (start.month === 1 && end.month === 12) {
            value = [formatStartDate(formatterYear), formatEndDate(formatterYear)];
        }
        else {
            value = [formatStartDate(formatterMonthYear), formatEndDate(formatterMonthYear)];
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.startOnly) && Array.isArray(value)) {
        var periodStart = value[0];
        value = periodStart;
    }
    /**
     * Remove os caracteres de abreviação devido a formatação
     *
     * @param text
     */
    var removeExtras = function (text) { return text.replace('. de', ''); };
    if (Array.isArray(value)) {
        value = value.map(removeExtras);
    }
    else {
        value = removeExtras(value);
    }
    if ((options === null || options === void 0 ? void 0 : options.join) && Array.isArray(value)) {
        return value.join(options.join);
    }
    return value;
}
exports.formatPeriod = formatPeriod;
function formatNumber(number, decimal) {
    if (number === void 0) { number = 0; }
    if (decimal === void 0) { decimal = 2; }
    var parseNumber = typeof number === 'string' ? parseFloat(number) : number;
    return numeral_1.default(parseNumber).format("0,0." + ''.padEnd(decimal, '0'), Math.floor);
}
exports.formatNumber = formatNumber;
function formatVolume(volume) {
    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        maximumFractionDigits: 3,
        minimumFractionDigits: 3,
    });
    return formatter.format(volume);
}
exports.formatVolume = formatVolume;
function formatNumberFromString(strValue, precision, locale) {
    if (precision === void 0) { precision = 2; }
    if (locale === void 0) { locale = 'pt-br'; }
    return Intl.NumberFormat(locale, {
        maximumFractionDigits: precision,
        minimumFractionDigits: precision,
    }).format(parseFloat(strValue));
}
exports.formatNumberFromString = formatNumberFromString;
function formatCurrency(number, decimal) {
    if (number === void 0) { number = 0; }
    if (decimal === void 0) { decimal = 2; }
    return "R$ " + formatNumber(number, decimal);
}
exports.formatCurrency = formatCurrency;
function formatNomeEmpresarial(name) {
    if (isEmpty_1.default(name)) {
        return '';
    }
    var regText = '([^\\u0000-\\u007F]|[A-Z/-])';
    var hasHifen = new RegExp("^" + regText + "+\\s-\\s" + regText + "+", 'gi');
    var hasPreposicao = new RegExp("^" + regText + "+\\s" + regText + "{1,3}\\s" + regText + "+", 'gi');
    var isNormal = new RegExp("^" + regText + "+\\s" + regText + "+", 'gi');
    var result = (hasHifen.exec(name) || hasPreposicao.exec(name) || isNormal.exec(name) || [name])[0];
    return result;
}
exports.formatNomeEmpresarial = formatNomeEmpresarial;
function formatClassePerfil(classe) {
    var mappingClassePerfil = {
        CONSUMIDOR_ESPECIAL: 'Especial',
        COMERCIALIZADOR: 'Comercializador',
        CONSUMIDOR_LIVRE: 'Livre',
    };
    return mappingClassePerfil[classe];
}
exports.formatClassePerfil = formatClassePerfil;
function formatSubmercadoPerfil(submercado) {
    var mappingSubmercadoPerfil = {
        NORTE: 'N',
        NORDESTE: 'NE',
        SUL: 'S',
        SUDESTE: 'SE/CO',
    };
    return mappingSubmercadoPerfil[submercado];
}
exports.formatSubmercadoPerfil = formatSubmercadoPerfil;
function formatSubmercadoPorExtenso(submercado) {
    var mappingSubmercadoPorExtenso = {
        NORTE: 'Norte',
        NORDESTE: 'Nordeste',
        SUL: 'Sul',
        SUDESTE: 'Sudeste/Centro Oeste',
    };
    return mappingSubmercadoPorExtenso[submercado];
}
exports.formatSubmercadoPorExtenso = formatSubmercadoPorExtenso;
function convertStringToSubmercado(submercado) {
    var ReverseMappingSubmercadoPerfil = {
        N: enums_1.Submercado.NORTE,
        NE: enums_1.Submercado.NORDESTE,
        S: enums_1.Submercado.SUL,
        'SE/CO': enums_1.Submercado.SUDESTE,
    };
    return ReverseMappingSubmercadoPerfil[submercado];
}
exports.convertStringToSubmercado = convertStringToSubmercado;
function convertStringToFonteEnergia(fonteEnergia) {
    var mappingFonteEnergia = {
        I0: enums_1.FonteEnergia.I0,
        I50: enums_1.FonteEnergia.I50,
        I100: enums_1.FonteEnergia.I100,
        CONV: enums_1.FonteEnergia.CONVENCIONAL,
    };
    return mappingFonteEnergia[fonteEnergia];
}
exports.convertStringToFonteEnergia = convertStringToFonteEnergia;
function formatSazonalidade(tipoSazonalidade) {
    if (tipoSazonalidade) {
        var mappingSazonalidade = {
            FLAT: 'Flat',
            SAZO_10: '±10%',
        };
        return mappingSazonalidade[tipoSazonalidade];
    }
    return 'N/A';
}
exports.formatSazonalidade = formatSazonalidade;
function formatFonteEnergiaPerfil(fonteEnergia) {
    var mappingFonteEnergiaPerfil = {
        I0: 'i0',
        I50: 'i50',
        I5: 'i50',
        I100: 'i100',
        CONVENCIONAL: 'CONV',
        CONV: 'Conv',
    };
    return mappingFonteEnergiaPerfil[fonteEnergia];
}
exports.formatFonteEnergiaPerfil = formatFonteEnergiaPerfil;
function formatFonteEnergiaPorExtenso(fonteEnergia) {
    var mappingFonteEnergiaPorExtenso = {
        I0: 'Incentivada 0',
        I50: 'Incentivada 50',
        I5: 'Incentivada 50',
        I100: 'Incentivada 100',
        CONVENCIONAL: 'Convencional',
        CONV: 'Convencional',
    };
    return mappingFonteEnergiaPorExtenso[fonteEnergia];
}
exports.formatFonteEnergiaPorExtenso = formatFonteEnergiaPorExtenso;
function getDescontoTarifaPorFonteEnergia(fonteEnergia) {
    var mappingFonteEnergiaPerfilZen = {
        I0: 'Sem desconto',
        I50: '50%',
        I5: '50%',
        I100: '100%',
        CONVENCIONAL: 'Não se aplica',
        CONV: 'Não se aplica',
    };
    return mappingFonteEnergiaPerfilZen[fonteEnergia];
}
exports.getDescontoTarifaPorFonteEnergia = getDescontoTarifaPorFonteEnergia;
function formatCondicoesComerciaisProposta(condicoesComerciais) {
    var nomeEmpresarial = formatNomeEmpresarial(condicoesComerciais.nomeEmpresarial);
    var periodo = formatPeriod(luxon_1.DateTime.fromISO(condicoesComerciais.inicioSuprimento), luxon_1.DateTime.fromISO(condicoesComerciais.fimSuprimento).minus({ day: 1 }), {
        join: ' - ',
        startOnly: condicoesComerciais === null || condicoesComerciais === void 0 ? void 0 : condicoesComerciais.isCurtoPrazo,
    });
    var fonteEnergia = formatFonteEnergiaPerfil(condicoesComerciais.fonteEnergia);
    var submercado = formatSubmercadoPerfil(condicoesComerciais.submercado);
    var pAtendimento = condicoesComerciais.percentualAtendimento;
    return nomeEmpresarial + " " + periodo + " " + submercado + " " + fonteEnergia + " " + pAtendimento + "%";
}
exports.formatCondicoesComerciaisProposta = formatCondicoesComerciaisProposta;
function formatCapitalized(valor) {
    return valor.replace(/(\b[a-z](?!\s))/g, function (c) { return c.toUpperCase(); });
}
exports.formatCapitalized = formatCapitalized;
exports.formatDocumentoStatus = function (value) {
    switch (value) {
        case 'APROVADO':
            return 'Aprovado';
        case 'RECUSADO':
            return 'Recusado';
        case 'ILEGIVEL':
            return 'Itens Ilegíveis';
        case 'INVALIDO':
            return 'Itens Inválidos';
        case 'IRREGULAR':
            return 'Itens Irregulares';
        case 'PENDENTE_ENVIO':
            return 'Envio pendente';
        case 'PENDENTE_AVALIACAO':
            return 'Avaliação pendente';
        case 'IGNORADO':
            return 'Itens Ignorados';
        default:
            throw new Error('Status Inválido');
    }
};
function formatCelular(value) {
    var regexCelular = new RegExp('^(?<ddd>[0-9]{2})(?<digit>[0-9]{1})(?<numberPartOne>[0-9]{4})(?<numberPartTwo>[0-9]{4})$', 'g');
    var celular = regexCelular.exec(value);
    if (celular === null || celular === void 0 ? void 0 : celular.groups) {
        celular.groups.ddd = "(" + celular.groups.ddd + ")";
        return Object.values(celular.groups).join(' ');
    }
    return value;
}
exports.formatCelular = formatCelular;
function formatCelularComTraco(value) {
    return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2 - $3');
}
exports.formatCelularComTraco = formatCelularComTraco;
function formatAmount(amount) {
    if (typeof amount !== 'number' || amount === 0) {
        return '--';
    }
    var rounded = Number(amount.toFixed(2));
    return rounded.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
exports.formatAmount = formatAmount;
